import * as gs from "@ivanlog/gs";
import { CmpWidgetLPXDetailsBase } from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { LPXReserves } from "../contracts/LPXContract";
import { BiMath } from "../libs/BiMath";
import { LPXInfo } from "../api/classes/models";
import { Web3Helper } from "../libs/Web3Helper";

export class CmpWidgetLPXDetails extends CmpWidgetLPXDetailsBase {

    private _lpxInf:LPXInfrastructure;
    private _poolReserve:LPXReserves;
    private _pool:LPXInfo;

    // private _resFund:bigint;
    // private _resFundImg:bigint;
    // private _resAnchor:bigint;
    // private _resAnchorImg:bigint;
    
    constructor() {
        super();
        this.hide();

        this.ctrls.btnClaimYield.onclick=()=>this._tryClaimYieldAsync();
    }

    public async refreshAsync(pool:LPXInfo)
    {
        const account = App.chain.account;   
        this._pool=pool;

        // this._resFund = BiMath.WEIToBI(this._pool.reserves.fundRaw);
        // this._resFundImg = BiMath.WEIToBI(this._pool.reserves.fundImgRaw);
        // this._resAnchor = BiMath.WEIToBI(this._pool.reserves.anchorRaw);
        // this._resAnchorImg = BiMath.WEIToBI(this._pool.reserves.anchorImgRaw);
        this._poolReserve = LPXReserves.FromLPXInfo(this._pool);

        const lpxInf=App.Inst.getInst(LPXInfrastructure);
        this._lpxInf=lpxInf;
        //TODO подумать о фии и переделать

        const fundAdr = this._pool.fundToken.erc20Address;
        const anchorAdr = this._pool.anchorToken.erc20Address;
        const fundDecimal = BiMath.Pow10(this._pool.fundToken.decimals);
        const anchorDecimal = BiMath.Pow10(this._pool.anchorToken.decimals);
        const pairDecimalCor = fundDecimal*BiMath.Decimal/anchorDecimal;

        const fundSymbol = this._pool.fundToken.symbol;
        const anchorSymbol = this._pool.anchorToken.symbol;
        const ctrl = this.ctrls;

        ctrl.lPoolId.text = "#"+this._pool.poolId;
        if (lpxInf.hasFlag(BiMath.WEIToBI(this._pool.packRaw), LPXInfrastructure.PACKFLAG_MANAGER_ONLY))
            ctrl.lPoolId.text = "SOLO #"+this._pool.poolId;

        ctrl.imgFund.el.src = "files/images/erc20/"+fundAdr.toLowerCase()+".webp";
        ctrl.imgAnchor.el.src = "files/images/erc20/"+anchorAdr.toLowerCase()+".webp";
        ctrl.lAnchorSymbol.text = anchorSymbol;
        ctrl.lFundSymbol.text = fundSymbol;

       // ctrl.tglClaimYield.inactive();
       // ctrl.tglRemoveLiquidity.inactive();

        const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(this._pool.packRaw));

        //Рассчет индексов
        const ntzEth = pack.ntzIndex*BiMath.Decimal/BiMath.Decimal17B*100n;
        const feeEth = pack.feeIndex*BiMath.Decimal/BiMath.Decimal17B*100n;//; BiMath.ToEth(feeBI/BigInt(2)*BigInt(100));
       
        const baseEth = ntzEth - (feeEth * 2n);

        const profitEth = pack.profitIndex*BiMath.Decimal/BiMath.Decimal17B*100n;
        let reinvestEth = 0n;
        if (pack.ntzIndex>pack.profitIndex+pack.feeIndex*BigInt(2))
            reinvestEth = ntzEth-profitEth-(feeEth*2n);
        const profitIndexEth = profitEth*BiMath.Decimal*100n/baseEth;
        const reinvestIndexEth = reinvestEth*BiMath.Decimal*100n/baseEth;
        const formatPercent = (value:bigint)=>{
            const precision = 1000n;
            const rounded = (value*precision+BiMath.Decimal/2n)/BiMath.Decimal;
            const integerPart = rounded/precision;
            const decimalPart = rounded%precision;
            if (decimalPart==0n) return integerPart+"";
            return `${integerPart}.${decimalPart.toString().padStart(3, "0").replace(/0+$/, "")}`;
        }
        //    reinvestEthP = BiMath.ToEth((pack.ntzIndex-(pack.profitIndex+pack.feeIndex*BigInt(2)))*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));



        const managerRewardEthP = BiMath.ToEth(pack.managerRewardIndex*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));

        ctrl.lAPR.text = "-";
        if (this._pool.aprAllTime)
            ctrl.lAPR.text = Math.trunc(this._pool.aprAllTime*10000)/100+"%";// this._lpxInf.getApr(this._pool.aprAllTime);
        ctrl.lNTZ.text = BiMath.ToEth(ntzEth)+"%";
        ctrl.lFee.text = BiMath.ToEth(feeEth)+"%";
        ctrl.lProfit.text = formatPercent(profitIndexEth)+"%";
        ctrl.lReinvested.text = formatPercent(reinvestIndexEth)+"%";
        ctrl.lManagerReward.text = managerRewardEthP+"%";
        //Рассчет цен

        ctrl.lFundAdr.text =fundAdr;
        ctrl.lAnchorAdr.text =anchorAdr;
        ctrl.lManagerAdr.text =this._pool.managerAddress;

        ctrl.btnCopyAdrFund.onclick=()=>{gs.helpers.text.copyToClipboard(fundAdr)}
        ctrl.btnCopyAdrAnchor.onclick=()=>{gs.helpers.text.copyToClipboard(anchorAdr)}
        ctrl.btnCopyAdrManager.onclick=()=>{gs.helpers.text.copyToClipboard(this._pool.managerAddress)}

        ctrl.lPriceEnd.text = 
        ctrl.lPriceBuy.text =
        ctrl.lPriceStart.text =
        ctrl.lPriceSell.text =
        ctrl.lPortfolio.text =
        ctrl.lYield.text =
        "-";
        ctrl.btnClaimYield.hide();

        if (this._poolReserve.fundImgReserve>0) ctrl.lPriceEnd.text = BiMath.ToEth(this._lpxInf.calcEndRatio(this._poolReserve, pack.feeIndex)
            *pairDecimalCor/BiMath.Decimal);
        if (this._poolReserve.anchorImgReserve>0) ctrl.lPriceStart.text = BiMath.ToEth(this._lpxInf.calcStartRatio(this._poolReserve, pack.feeIndex)
            *(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B
            *pairDecimalCor/BiMath.Decimal);
        
        if (this._poolReserve.fundReserve + this._poolReserve.fundImgReserve>0)
        {
            ctrl.lPriceBuy.text = BiMath.ToEth(this._lpxInf.calcCurrentRatio(this._poolReserve)*(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B*pairDecimalCor/BiMath.Decimal);
            ctrl.lPriceSell.text = BiMath.ToEth(this._lpxInf.calcCurrentRatio(this._poolReserve)*pairDecimalCor/BiMath.Decimal);
        }

        let poolType = "Unknown";
        switch(pack.poolType)
        {
            case LPXInfrastructure.POOLTYPE_DUAL:poolType = "Custom LPX"; break;
            case LPXInfrastructure.POOLTYPE_DIRECTION:poolType = "Directional"; break;
        }
        ctrl.lType.text = poolType;

        this.show();

        if (!account) return;

        // if (BiMath.WEIToBI(this._pool.sharesTotalRaw)==0n)
        // {
        //     if (account.toLocaleLowerCase()==this._pool.managerAddress.toLocaleLowerCase())
        //     {
        //         await ctrl.cmpLPXControl.refreshAsync(this._pool);
        //         ctrl.cmpLPXControl.show();
        //     }
        // } else
        // {
        //     ctrl.cmpLPXControl.hide();
        // }

        ctrl.lPortfolio.text="-";
        if (this._pool.shareMy.shareRaw!="0")
        {
            const shareBI = BiMath.WEIToBI(this._pool.shareMy.shareRaw);
            const shareIndexBI = shareBI*BiMath.Decimal/BiMath.WEIToBI(this._pool.sharesTotalRaw)
            const fundShareBi = BiMath.WEIToBI(this._pool.reserves.fundRaw)*shareIndexBI/BiMath.Decimal;
            const anchorShareBi = BiMath.WEIToBI(this._pool.reserves.anchorRaw)*shareIndexBI/BiMath.Decimal;
            const fundShare = Web3Helper.ToLargeNumberUnit(fundShareBi*BiMath.Decimal/fundDecimal);
            const anchorShare = Web3Helper.ToLargeNumberUnit(anchorShareBi*BiMath.Decimal/anchorDecimal);
            let sharePercent = Math.trunc(parseFloat(BiMath.ToEth(shareIndexBI))*1000000)/10000;
            if (sharePercent==0)sharePercent=0.0001;
            ctrl.lPortfolio.text = `${fundShare} ${this._pool.fundToken.symbol} / ${anchorShare} ${this._pool.anchorToken.symbol} (${sharePercent}%)`;
        
            const share = this._pool.shareMy;
            const ppsBI = BiMath.WEIToBI(this._pool.profitPerShareRaw);
            const profitBI = ((ppsBI-BiMath.WEIToBI(share.debtRaw))*shareBI/BiMath.Decimal+BiMath.WEIToBI(share.pendingRaw));
            const profitStr = Web3Helper.ToLargeNumberUnit(profitBI*BiMath.Decimal/anchorDecimal,6);

            const shareArb = this._pool.shareMyArb;
            const ppsArbBI = BiMath.WEIToBI(this._pool.profitPerShareArbRaw);
            const profitArbBI = ((ppsArbBI-BiMath.WEIToBI(shareArb.debtRaw))*shareBI/BiMath.Decimal+BiMath.WEIToBI(shareArb.pendingRaw));
            const profitArbStr = Web3Helper.ToLargeNumberUnit(profitArbBI*BiMath.Decimal/anchorDecimal,6);
            ctrl.lYield.text = `Maker ${profitStr} ${pool.anchorToken.symbol} +\nArbitrage ${profitArbStr} ${pool.anchorToken.symbol}`;
            if (profitBI+profitArbBI==BiMath.Zero) ctrl.btnClaimYield.disable();
            else ctrl.btnClaimYield.enable();
            ctrl.btnClaimYield.show();
        } else
        {
            ctrl.lYield.text = "-";
            ctrl.btnClaimYield.hide();
        }
    }



    private async _tryClaimYieldAsync()
    {
        const result = await this._lpxInf.lpxCtrlPools.claimProfits([this._pool.poolId],false);
        if (result) this._informTxSuccessful();
        this._lpxInf.refreshAsync();
    }

    private _informTxSuccessful() { App.gui.dialogOkShowAsync("✅Transaction successful!","") }
}
